<template>
  <modal
    name="modal-preview-table"
    scrollable
    width="100%"
    height="100%"
    :clickToClose="false"
  >
    <div class="modal-preview-content">
      <!-- Cabeçalho do Modal -->
      <div class="modal-preview-cabecalho m-3">
        <div
          class="back-arrow-squared"
          @click="fecharModalPreviewTable"
          title="Fechar visualização"
        >
          <i class="flaticon-up-arrow" style="color: #808080 !important"></i>
        </div>
      </div>

      <!-- Conteúdo da Tabela -->
      <div class="tabela-container">
        <!-- Tabela de Visualização -->
        <DataTable
          class="p-datatable-sm prime-preview-table"
          :value="tableContent"
          stripedRows
          paginator
          showGridlines
          resizableColumns
          columnResizeMode="expand"
          :rows="porPagina"
          :rowsPerPageOptions="paginaQuantidadeOpcoes"
          ref="dt"
          filterDisplay="menu"
          :filters.sync="filters1"
          :globalFilterFields="globalFilterFields"
          selectionMode="single"
          scrollHeight="flex"
          responsiveLayout="scroll"
        >
          <!-- :scrollable="true" -->
          <template #header>
            <div class="d-flex justify-content-between">
              <Button
                icon="pi pi-external-link"
                label="Exportar"
                class="p-button-outlined"
                @click="exportarExcel"
                v-if="isAccountAdmin || checkSuperAdmin"
                title="Exportar para Excel"
              />
              <div>
                <MultiSelect
                  :value="selectedColumns"
                  :options="columns"
                  optionLabel="header"
                  @input="onToggle"
                  placeholder="Selecionar colunas"
                  style="width: 20em"
                  filter
                  class="mr-1"
                />
                <Button
                  type="button"
                  icon="pi pi-filter-slash"
                  label="Limpar"
                  class="p-button-outlined mr-3"
                  @click="clearFilter1"
                />
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters1['global'].value"
                    placeholder="Pesquisar..."
                  />
                </span>
              </div>
            </div>
          </template>
          <template #empty>Sem dados para exibir.</template>
          <template #loading>Carregando dados. Por favor, aguarde.</template>
          <Column
            v-for="column in visibleColumns"
            :key="column.field"
            :field="column.field"
            :header="column.header"
            :filterField="column.field"
            sortable
          >
            <template v-slot:body="{ data }">
              <span
                v-if="isNullValue(data[column.field])"
                class="null-value-indicator"
              >
                [NULL]
              </span>
              <span v-else>{{ data[column.field] }}</span>
            </template>
            <template v-slot:filter="{ filterModel }">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                :placeholder="'Filtrar por ' + column.header"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </modal>
</template>

<script>
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import MultiSelect from "primevue/multiselect";

export default {
  props: ["tableContent", "tableHeaders"],
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    MultiSelect
  },
  data() {
    return {
      porPagina: 50,
      paginaQuantidadeOpcoes: [5, 10, 30, 50, 100, 500],
      selectedColumns: [],
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      globalFilterFields: []
    };
  },
  mounted() {
    this.initFiltersAndGlobals();
  },
  methods: {
    fecharModalPreviewTable() {
      this.$modal.hide("modal-preview-table");
    },
    formatarDataMenorQue10(data) {
      return data < 10 ? "0" + data : data;
    },
    exportarExcel() {
      const dataHoje = new Date();
      const dataFormatada = `${this.formatarDataMenorQue10(
        dataHoje.getDate()
      )}-${this.formatarDataMenorQue10(
        dataHoje.getMonth() + 1
      )}-${dataHoje.getFullYear()} ${this.formatarDataMenorQue10(
        dataHoje.getHours()
      )}:${this.formatarDataMenorQue10(
        dataHoje.getMinutes()
      )}:${this.formatarDataMenorQue10(dataHoje.getSeconds())}`;
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(this.tableContent);
      XLSX.utils.book_append_sheet(wb, ws, "Preview");
      XLSX.writeFile(wb, `Preview ${dataFormatada}.xlsx`);
    },
    clearFilter1() {
      Object.keys(this.filters1).forEach((key) => {
        const filtro = this.filters1[key];

        if (filtro && Array.isArray(filtro.constraints)) {
          filtro.constraints.forEach((constraint) => {
            constraint.value = null;
          });
          return;
        }

        if (filtro && Object.prototype.hasOwnProperty.call(filtro, "value")) {
          filtro.value = null;
        }
      });
    },
    initFiltersAndGlobals() {
      this.filters1 = {
        global: { value: null, matchMode: "contains" }
      };

      this.normalizedHeaders.forEach((col) => {
        this.filters1[col.field] = {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        };
      });

      this.syncSelectedColumns();
      this.globalFilterFields = this.visibleColumns.map((col) => col.field);
    },
    syncSelectedColumns() {
      const selectedFields = new Set(
        (this.selectedColumns || []).map((col) => col.field)
      );

      const selected = this.normalizedHeaders.filter((col) =>
        selectedFields.has(col.field)
      );

      this.selectedColumns = selected.length
        ? selected
        : [...this.normalizedHeaders];
    },
    onToggle(value) {
      this.selectedColumns = value || [];
      this.globalFilterFields = this.visibleColumns.map((col) => col.field);
    },
    isNullValue(value) {
      return value === null;
    }
  },
  computed: {
    columns() {
      return this.normalizedHeaders;
    },
    visibleColumns() {
      return this.selectedColumns.length
        ? this.selectedColumns
        : this.normalizedHeaders;
    },
    normalizedHeaders() {
      const headers =
        this.tableHeaders && this.tableHeaders.length
          ? this.tableHeaders
          : Object.keys((this.tableContent && this.tableContent[0]) || {});

      return headers
        .map((header) => {
          if (typeof header === "string") {
            return { field: header, header };
          }

          const field = header.field || header.key;
          const headerText = header.header || header.label || field;

          return field ? { field, header: headerText } : null;
        })
        .filter(Boolean);
    },
    ...mapGetters(["checkSuperAdmin", "isAccountAdmin"])
  },
  watch: {
    tableHeaders() {
      this.initFiltersAndGlobals();
    },
    tableContent() {
      this.initFiltersAndGlobals();
    }
  }
};
</script>

<style>
/* Modal em tela cheia */
.vm--container.scrollable .vm--modal {
  overflow: hidden;
}

.modal-preview-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Tabela ocupando toda a tela com rolagem vertical */
.tabela-container {
  flex: 1;
  min-height: 0;
  padding: 0 16px;
  display: flex;
  scrollbar-width: thin;
  scrollbar-color: #cfcfcf #f0f0f0;
}

.prime-preview-table {
  width: 100%;
  height: 100%;
}

.prime-preview-table.p-datatable {
  display: flex;
  flex-direction: column;
}

.prime-preview-table .p-datatable-wrapper {
  flex: 1;
}

/* Estilos da Barra de Rolagem */
.tabela-container::-webkit-scrollbar {
  width: 8px;
}

.tabela-container::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.tabela-container::-webkit-scrollbar-thumb {
  background-color: #cfcfcf;
  border-radius: 4px;
}

/* Estilos da Paginação */
.paginacao-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
}

/* Botão de Fechar no Modal */
.back-arrow-squared {
  border: 1px solid #808080;
  border-radius: 4px;
  transform: rotate(-90deg);
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-arrow-squared:hover {
  background-color: #f0f0f0;
}

.null-value-indicator {
  color: #9ca3af;
  font-style: italic;
}
</style>
